export default __webpack_public_path__ + "static/media/imageUploadIcon.730e9234.svg";